module.exports = __webpack_public_path__ + "img/logo_crypto_com.c06d60a.png";